import { useState, useEffect } from 'react';
import { Tab } from '@headlessui/react';
import { Dialog } from '@headlessui/react';
import {QuickAccountForm, QuickVendorForm} from "./Forms/QuickForms";
import {API} from "../api/config";
import * as item from "date-fns/locale";

const AccountsVendorsScreen = () => {
    const [selectedTab, setSelectedTab] = useState(0);
    const [accounts, setAccounts] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);

    useEffect(() => {
        fetchAccounts();
        fetchVendors();
    }, []);

    const fetchAccounts = async () => {
        const response = await fetch(API.accounts.list());
        setAccounts(await response.json());
    };

    const fetchVendors = async () => {
        const response = await fetch(API.vendors.list());
        setVendors(await response.json());
    };

    const handleNew = (type) => {
        setModalType(type);
        setSelectedItem(null);
        setShowModal(true);
    };

    const handleEdit = (type, item) => {
        setModalType(type);
        setSelectedItem(item);
        setShowModal(true);
    };

    const handleDelete = async (type, id) => {
        // eslint-disable-next-line no-restricted-globals
        if (!confirm('Are you sure you want to delete this item?')) return;
        await fetch(type === 'accounts' ? API.accounts.delete(item.id) : API.vendors.delete(item.id), { method: 'DELETE' });
        if (type === 'accounts') fetchAccounts();
        else fetchVendors();
    };

    const handleModalClose = () => {
        setShowModal(false);
        fetchAccounts();
        fetchVendors();
    };

    return (
        <div className="container mx-auto p-6">
            <Tab.Group selectedIndex={selectedTab} onChange={setSelectedTab}>
                <div className="flex justify-between items-center mb-6">
                    <Tab.List className="flex gap-4">
                        <Tab className={({ selected }) =>
                            `px-4 py-2 rounded-lg ${selected ? 'bg-blue-500 text-white' : 'bg-gray-100'}`
                        }>
                            Accounts
                        </Tab>
                        <Tab className={({ selected }) =>
                            `px-4 py-2 rounded-lg ${selected ? 'bg-blue-500 text-white' : 'bg-gray-100'}`
                        }>
                            Vendors
                        </Tab>
                    </Tab.List>
                    <button
                        onClick={() => handleNew(selectedTab === 0 ? 'accounts' : 'vendors')}
                        className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600"
                    >
                        + New {selectedTab === 0 ? 'Account' : 'Vendor'}
                    </button>
                </div>

                <Tab.Panels>
                    <Tab.Panel>
                        <div className="bg-white rounded-lg shadow">
                            <table className="min-w-full">
                                <thead>
                                <tr className="bg-gray-50">
                                    <th className="px-6 py-3 text-left text-sm font-medium text-gray-500">Name</th>
                                    <th className="px-6 py-3 text-left text-sm font-medium text-gray-500">Account Number</th>
                                    <th className="px-6 py-3 text-right text-sm font-medium text-gray-500">Actions</th>
                                </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                {accounts.map(account => (
                                    <tr key={account.id} className="hover:bg-gray-50">
                                        <td className="px-6 py-4 text-sm text-gray-900">{account.name}</td>
                                        <td className="px-6 py-4 text-sm text-gray-900">{account.accountNumber}</td>
                                        <td className="px-6 py-4 text-right space-x-2">
                                            <button
                                                onClick={() => handleEdit('accounts', account)}
                                                className="text-blue-600 hover:text-blue-900"
                                            >
                                                Edit
                                            </button>
                                            <button
                                                onClick={() => handleDelete('accounts', account.id)}
                                                className="text-red-600 hover:text-red-900"
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </Tab.Panel>

                    <Tab.Panel>
                        <div className="bg-white rounded-lg shadow">
                            <table className="min-w-full">
                                <thead>
                                <tr className="bg-gray-50">
                                    <th className="px-6 py-3 text-left text-sm font-medium text-gray-500">Name</th>
                                    <th className="px-6 py-3 text-left text-sm font-medium text-gray-500">Email</th>
                                    <th className="px-6 py-3 text-left text-sm font-medium text-gray-500">Phone</th>
                                    <th className="px-6 py-3 text-right text-sm font-medium text-gray-500">Actions</th>
                                </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                {vendors.map(vendor => (
                                    <tr key={vendor.id} className="hover:bg-gray-50">
                                        <td className="px-6 py-4 text-sm text-gray-900">{vendor.name}</td>
                                        <td className="px-6 py-4 text-sm text-gray-900">{vendor.email}</td>
                                        <td className="px-6 py-4 text-sm text-gray-900">{vendor.phone}</td>
                                        <td className="px-6 py-4 text-right space-x-2">
                                            <button
                                                onClick={() => handleEdit('vendors', vendor)}
                                                className="text-blue-600 hover:text-blue-900"
                                            >
                                                Edit
                                            </button>
                                            <button
                                                onClick={() => handleDelete('vendors', vendor.id)}
                                                className="text-red-600 hover:text-red-900"
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </Tab.Panel>
                </Tab.Panels>
            </Tab.Group>

            <Dialog open={showModal} onClose={() => setShowModal(false)} className="relative z-50">
                <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
                <div className="fixed inset-0 flex items-center justify-center p-4">
                    <Dialog.Panel className="mx-auto max-w-lg bg-white rounded-xl p-6">
                        {modalType === 'accounts' ? (
                            <QuickAccountForm
                                initialData={selectedItem}
                                onSubmit={handleModalClose}
                            />
                        ) : (
                            <QuickVendorForm
                                initialData={selectedItem}
                                onSubmit={handleModalClose}
                            />
                        )}
                    </Dialog.Panel>
                </div>
            </Dialog>
        </div>
    );
};

export default AccountsVendorsScreen;